import React from 'react';

const TimelineMerchantUnableToFulfill = ({ fill }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 17.3"
      xmlSpace="preserve"
      fill={fill}
      className="card-icon"
    >
      <title>Unable to Fulfill</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-577.000000, -1695.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Unableto-Fulfill" transform="translate(0.000000, 792.000000)">
                <g id="Icon" transform="translate(31.000000, 0.000000)">
                  <g id="Avatar">
                    <g id="file-alt-light" transform="translate(14.000000, 19.000000)">
                      <path
                        id="Shape"
                        fill={fill}
                        d="M8.89959649,7.92834085 L7.12793734,9.7 L8.89959649,11.4716592 C9.03346784,11.6055305 9.03346784,11.8220033 8.89959649,11.9558747 L8.25587467,12.5995965 C8.12200332,12.7334678 7.9055305,12.7334678 7.77165915,12.5995965 L6,10.8279373 L4.22834085,12.5995965 C4.0944695,12.7334678 3.87799668,12.7334678 3.74412533,12.5995965 L3.10040351,11.9558747 C2.96653216,11.8220033 2.96653216,11.6055305 3.10040351,11.4716592 L4.87206266,9.7 L3.10040351,7.92834085 C2.96653216,7.7944695 2.96653216,7.57799668 3.10040351,7.44412533 L3.74412533,6.80040351 C3.87799668,6.66653216 4.0944695,6.66653216 4.22834085,6.80040351 L6,8.57206266 L7.77165915,6.80040351 C7.9055305,6.66653216 8.12200332,6.66653216 8.25587467,6.80040351 L8.89959649,7.44412533 C9.03346784,7.57799668 9.03346784,7.7944695 8.89959649,7.92834085 L8.89959649,7.92834085 Z M10.5,2 L8,2 C8,0.896875 7.103125,0 6,0 C4.896875,0 4,0.896875 4,2 L1.5,2 C0.671875,2 0,2.671875 0,3.5 L0,14.5 C0,15.328125 0.671875,16 1.5,16 L10.5,16 C11.328125,16 12,15.328125 12,14.5 L12,3.5 C12,2.671875 11.328125,2 10.5,2 Z M6,1.5 C6.275,1.5 6.5,1.725 6.5,2 C6.5,2.275 6.275,2.5 6,2.5 C5.725,2.5 5.5,2.275 5.5,2 C5.5,1.725 5.725,1.5 6,1.5 Z M10.5,14.25 C10.5,14.3875 10.3875,14.5 10.25,14.5 L1.75,14.5 C1.6125,14.5 1.5,14.3875 1.5,14.25 L1.5,3.75 C1.5,3.6125 1.6125,3.5 1.75,3.5 L3,3.5 L3,4.5 C3,4.775 3.225,5 3.5,5 L8.5,5 C8.775,5 9,4.775 9,4.5 L9,3.5 L10.25,3.5 C10.3875,3.5 10.5,3.6125 10.5,3.75 L10.5,14.25 Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineMerchantUnableToFulfill;

